import { SettingConst } from '../../types';

/**
 * Enable modal popup when the user requests a callback and the callback request is queued
 */
export const HELP_CENTER_PHONE_CALLBACK_QUEUE_MODAL_241009 =
  'HELP_CENTER_PHONE_CALLBACK_QUEUE_MODAL_241009' as SettingConst<
    'HELP_CENTER_PHONE_CALLBACK_QUEUE_MODAL_241009',
    boolean,
    'HELP_CENTER'
  >;
